/*   Library  */
import React, { useState, useEffect } from 'react'
import { withRouter } from "react-router-dom";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DateFnsUtils from "@date-io/date-fns";
import { TextField, Button, Typography, Grid, FormControl } from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks'
import MaterialTable from 'material-table';
import GetAppIcon from '@material-ui/icons/GetApp';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment'
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash'

/* Import Component  */
import { CommponExport } from '../../../components/ExportReport/CommponExport'
import { APPROVEPENDINGREPORT } from './ApproPendingQuery';
import { LotNo } from '../../../components/DropdownSelect/LotNo';
import { CompanyAndPartyAllData } from '../../../components/DropdownSelect/SelectComponents/companyAndPartySelectComponent';
import { Tofixed } from '../../../components/Comman/Tofix';
import { useStyles, Accordion, AccordionSummary, AccordionDetails } from '../../../components/Comman/Accordian'
import { PrintDiv, exportTableToExcel } from '../../../components/Comman/exportPdfAndExcel'
import { ExportCsv } from '../../../components/ExportReport/ExportCsv'
import * as XLSX from 'xlsx/xlsx.mjs';

import ExcelPng from '../../../../Excel.png'
/* css  */
import './appro.css'


const columns = [
  {
    title: 'Date', field: 'date', render: (rowData) => {
      if (rowData.date === "Grand Total") return rowData.date
      else return moment(rowData.date).format('DD/MM/YYYY')
    }
  },
  {
    title: 'Lab Name',
    field: 'partyId.partyName',

  },
  {
    title: 'Lot No',
    field: 'lotNoId.lotNo',

  },
  {
    title: 'Packet No',
    field: 'pktNo',
    render: (rowData) => {
      if (rowData.date === "Grand Total") {
        return rowData?.pktNo || ''
      }
      return rowData?.pktNoId?.pktNo || ''
    }
  },
  {
    title: 'Cts',
    field: 'cts',
    render: (rowData) => Tofixed(rowData?.cts || 0)

  },
  {
    title: 'shape',
    field: 'shapeId.shortName'
  },
  {
    title: 'Polish',
    field: 'polishId.shortName'
  },
  {
    title: 'Symn.',
    field: 'symmId.shortName'
  },
  {
    title: 'Flu',
    field: 'fluId.shortName'
  },
  {
    title: 'Lab',
    field: 'labId.partyName'
  },
  {
    title: 'measurment',
    field: 'measurment'
  },
  {
    title: 'certificateNo',
    field: 'certificateNo'
  },
  {
    title: 'rfId',
    field: 'rfId'
  },
]

function ApproPending() {
  const classes = useStyles();
  const [selectedFromDate, setSelectedFromDate] = useState(moment().subtract(7, "days"));
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [filter, setFilter] = useState({})
  const [partyName, setPartyName] = useState('');
  const [lotNo, setLotNo] = useState('');

  const [AllData, setAllData] = useState([]);
  const [ResultData, setResultData] = useState([]);

  const { data, loading, refetch } = useQuery(APPROVEPENDINGREPORT, {
    variables: { filter: JSON.stringify(filter) },
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    let result = data?.getApproPendingReport || []
    let GetGrandTotalData = result.filter(d => d.date === "Grand Total")
    if (result.length !== 0 && GetGrandTotalData.length === 0) {
      let LastRow = {
        date: "Grand Total",
        pktNo: result?.length || 0,
        cts: Tofixed(_.sum(_.map(result, 'cts')))
      }
      result.push(LastRow)
    }
    setResultData(result)
    let Data = _.cloneDeep(result)
    setAllData(Data)
  }, [data])

  let defaultProps = LotNo('', '', '').defaultProps
  let parties = CompanyAndPartyAllData("PARTY");

  useEffect(() => {
    let Data = JSON.parse(localStorage.getItem('ApproPendingReport') || "{}")
    if (Data.lotNoId) {
      setLotNo(_.find(defaultProps?.options || [], (d) => d.id === Data.lotNoId))
    }
    if (Data.partyId) {
      setPartyName(_.find(parties || [], (d) => d.id === Data.partyId))
    }
    if (Data.fromDate) {
      setSelectedFromDate(moment(Data.fromDate))
    }
    if (Data.toDate) {
      setSelectedToDate(moment(Data.toDate))
    }
    if (Object.keys(Data).length > 0)
      setFilter(Data)
  }, [])


  function exportExcelFile(workbook) {
    return XLSX.writeFile(workbook, `ApprovePendingReport${moment()}.xlsx`);
  }

  const exportCsvData = () => {
    var workbook = XLSX.utils.book_new();
    var worksheet_data = document.getElementById("table-to-xls");
    var worksheet = XLSX.utils.table_to_sheet(worksheet_data);
    workbook.SheetNames.push("Test");
    workbook.Sheets["Test"] = worksheet;
    exportExcelFile(workbook);
  }

  const PreViewHandler = () => {
    let Data = {}
    if (lotNo) {
      Data = { ...Data, "lotNoId": lotNo.id }
    }
    if (partyName) {
      Data = { ...Data, "partyId": partyName.id }
    }
    if (selectedFromDate) {
      Data = { ...Data, "fromDate": moment(selectedFromDate).format('YYYY-MM-DD') }
    }
    if (selectedToDate) {
      Data = { ...Data, "toDate": moment(selectedToDate).format('YYYY-MM-DD') }
    }
    setFilter(Data)
    localStorage.setItem('ApproPendingReport', JSON.stringify(Data))
  }

  const ClearViewHandler = () => {
    setLotNo('')
    setPartyName('')
    setSelectedFromDate(moment().subtract(7, "days"))
    setSelectedToDate(new Date())
    setAllData([])
    setResultData([])
    localStorage.removeItem('ApproPendingReport')
    setFilter({}, () => {
      refetch()
    })
  }

  const pdfHeader = () => {
    return <div>
      <h2 style={{ textAlign: "center" }}>Appro Pending Report</h2>
      <p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>Company Name : KISMET DIAMONDS</p>
      <p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>Party Name : {partyName?.partyName || "All"}</p>
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ width: "50%" }}>
          < p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}> Lot No : {lotNo?.lotNo || "All"}</p>
        </div>
        <div>
          < p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>{`Date : ${moment(selectedFromDate).format('DD-MM-YYYY')} To: ${moment(selectedToDate).format('DD-MM-YYYY')}`}</p>
        </div>
      </div>
    </div>
  }

  const TableHeader = () => {
    return <>
      <tr>
        <td colSpan={columns.length}><div ><h2 style={{ textAlign: "center" }}>Appro Pending Report</h2></div></td>
      </tr>
      <tr >
        <td colSpan={columns.length - 1}>
          <p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>Company Name : KISMET DIAMONDS</p>

        </td>
        <td colSpan={1} style={{ textAlign: "end" }}>
          < p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}> Lot No : {lotNo?.lotNo || "All"}</p>
        </td>
      </tr>
      <tr>
        <td colSpan={columns.length - 1} >
          <p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>Party Name : {partyName?.partyName || "All"}</p>
        </td>
        <td colSpan={1} style={{ textAlign: "end" }}>
          < p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>{`Date : ${moment(selectedFromDate).format('DD-MM-YYYY')} To: ${moment(selectedToDate).format('DD-MM-YYYY')}`}</p>
        </td>
      </tr>
    </>
  }

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Filters</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container justify="space-around">
            <form className={"makeStyles-root-30"} noValidate autoComplete="off">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl className={classes.formControl} style={{ paddingTop: 0 }}>
                  <Autocomplete
                    value={lotNo}
                    {...defaultProps}
                    onChange={(e, newdata) => {
                      if (newdata) {
                        setLotNo(newdata)
                      }
                    }}
                    className="lotmarginCustom"
                    renderInput={(params) => <TextField label="Lot No"  {...params} margin="normal" />}
                  />
                </FormControl>
                <FormControl className={classes.formControl} style={{ paddingTop: 0 }}>
                  <Autocomplete
                    value={partyName}
                    options={parties}
                    getOptionLabel={(option) => option.partyName}
                    onChange={(e, newdata) => {
                      if (newdata) {
                        setPartyName(newdata)
                      }
                    }}
                    className="lotmarginCustom"
                    renderInput={(params) => <TextField label="Party Name"  {...params} margin="normal" />}
                  />
                </FormControl>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-from"
                  label="From Date"
                  format="dd/MM/yyyy"
                  value={selectedFromDate}
                  onChange={e => setSelectedFromDate(e)}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                  style={{ marginTop: 0 }}
                />&nbsp;&nbsp;&nbsp;&nbsp;
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-to"
                  label="To Date"
                  format="dd/MM/yyyy"
                  value={selectedToDate}
                  onChange={e => setSelectedToDate(e)}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                  style={{ marginTop: 0 }}
                />
              </MuiPickersUtilsProvider>

              <Button
                onClick={() => PreViewHandler()}
                variant="contained"
                color="primary"
                style={{ height: 34, marginLeft: 10, marginTop: 12 }}>
                Preview
              </Button>
              <Button
                onClick={() => ClearViewHandler()}
                variant="contained"
                color="primary"
                style={{ height: 34, marginLeft: 10, marginTop: 12 }}>
                clear
              </Button>
            </form>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Grid container>
        <Grid item xs={12} style={{ position: "relative" }}>
          <img id="amits" className="download-table-xls-button" src={ExcelPng} alt="alternative text" title="csv" onClick={() => exportCsvData()} />
          <ExportCsv
            columns={columns}
            TableHeader={TableHeader()}
            AllData={AllData.filter(d => {
              d["partyId.partyName"] = d?.partyId?.partyName || " "
              d["lotNoId.lotNo"] = d?.lotNoId?.lotNo || " "
              d["pktNoId.pktNo"] = d?.pktNoId?.pktNo || " "
              d["fluId.shortName"] = d?.fluId?.shortName || " "
              d["shapeId.shortName"] = d?.shapeId?.shortName || " "
              d["polishId.shortName"] = d?.polishId?.shortName || " "
              d["symmId.shortName"] = d?.symmId?.shortName || " "
              d["labId.partyName"] = d?.labId?.partyName || " "
              return d
            })}
          />
          <MaterialTable
            title="Appro Pending Report"
            columns={columns}
            data={ResultData}
            isLoading={loading}
            options={{
              emptyRowsWhenPaging: false,
              debounceInterval: 300,
              padding: 'dense',
              pageSize: 10,
              pageSizeOptions: [5, 10, 15, 20, 25, 50],
              addRowPosition: 'first',
              filtering: true,
              sorting: true,
              search: false,
              filterCellStyle: { padding: '5px', },
              paging: false,
              maxBodyHeight: window.innerHeight - 215,
              // exportButton: true,
              rowStyle: rowData => ({
                backgroundColor: (rowData.date === "Grand Total") ? 'rgb(212, 218, 255)' : '#f5f5f5',
                fontWeight: (rowData.date === "Grand Total" || rowData.currency === "Grand Total") && 'bolder'
              }),
              headerStyle: { backgroundColor: 'whitesmoke' }
            }}
            actions={[
              {
                icon: 'print',
                tooltip: 'PRINT',
                isFreeAction: true,
                onClick: (event) => PrintDiv()
              },
              // {
              //   icon: GetAppIcon,
              //   tooltip: 'EXPORT',
              //   isFreeAction: true,
              //   onClick: (e) => exportTableToExcel("ExportTable", `${"Approve_Pending_Report"}_${moment()}`, e)
              // }
            ]}
          />
        </Grid>
      </Grid>

      {/* ==================================printDiv Start========================================= */}

      <CommponExport
        columns={columns}
        pdfHeader={pdfHeader()}
        AllData={AllData.filter(d => {
          d["partyId.partyName"] = d?.partyId?.partyName || " "
          d["lotNoId.lotNo"] = d?.lotNoId?.lotNo || " "
          d["pktNoId.pktNo"] = d?.pktNoId?.pktNo || " "
          return d
        })}
      />
      {/* ==================================printDiv End========================================= */}

    </div >

  );
}
export default withRouter(ApproPending)
